export function generatePagination(currentPage: number, lastPage: number, delta = 1) {
    const left = currentPage - delta;
    const right = currentPage + delta + 1;
    const range = [];
    const rangeWithDots = [];
    let l;

    range.push(1);

    for (let i = currentPage - delta; i <= currentPage + delta; i++) {
        if (i >= left && i < right && i < lastPage && i > 1) {
            range.push(i);
        }
    }

    range.push(lastPage);

    for (const i of range) {
        if (l) {
            if (i - l === 2) {
                rangeWithDots.push(l + 1);
            } else if (i - l !== 1) {
                rangeWithDots.push('...');
            }
        }

        rangeWithDots.push(i);
        l = i;
    }

    return rangeWithDots;
}
